// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".birthdays-detail{width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;grid-gap:10px;gap:10px}", ""]);
// Exports
module.exports = exports;
